import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-red-arrow-right",
  "use": "icon-red-arrow-right-usage",
  "viewBox": "0 0 6 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 11\" id=\"icon-red-arrow-right\"><path d=\"M2 10.5H0V.5h2v2h2v2h2v2H4v2H2v2z\" fill=\"#CF001F\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol